export function getSafeImageUrl(url: string | number[] | null | undefined): string | undefined {
  if (!url || typeof url !== 'string') return undefined

  const trimmed = url.trim()
  if (/^https?:\/\//i.test(trimmed)) return trimmed
  if (/^data:image\//i.test(trimmed)) return trimmed

  return undefined
}
